module.exports = __webpack_public_path__ + "img/Intranet_Head2_2_2.dfb35939.png";